import { SxProps, Theme } from '@mui/material/styles';

export const accessDeniedContainer: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '100vh',
  padding: 3,
};

export const accessDeniedTitle = (theme: Theme): SxProps<Theme> => ({
  fontWeight: theme.typography.fontWeightBold,
  color: theme.palette.grey[600],
  marginBottom: 2,
});

export const accessDeniedMessage = (theme: Theme): SxProps<Theme> => ({
  color: theme.palette.grey[700],
  maxWidth: 600,
  lineHeight: 1.6,
});

export const accessDeniedButton = (theme: Theme): SxProps<Theme> => ({
  mt: 2,
  backgroundColor: '#000000',
  color: '#FFFFFF',
  '&:hover': {
    backgroundColor: '#1A1A1A !important',
  },
  '&:active': {
    backgroundColor: '#000000',
  },
  '&:focus': {
    backgroundColor: '#000000',
  },
});
